import * as constants from '../../../constants/SwitchTransaction';
import * as commonConstants from '../../../constants/common';
import { getDateOrdinal } from '../../../utils/date';

export const investmentTimeFrameSelectedMatchesUserRiskProfile = (
  timeFrame: string,
  investmentTimeFrameFromResponse
) => {
  const timeFrameCode = commonConstants.INVESTMENT_TIME_FRAME_MAPPING[timeFrame];
  const timeFrameList = ['T1', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'];
  const indexOFTimeFrame = timeFrameList.indexOf(timeFrameCode);
  const indexOfTimeFrameFromBackend = timeFrameList.indexOf(investmentTimeFrameFromResponse);
  if (indexOFTimeFrame < indexOfTimeFrameFromBackend) {
    return true;
  } else {
    return false;
  }
};

export const validateStepAmountOrUnit = (value1: number, value2: number) => {
  let decimalLength = value2.toString().split('.')[1] ? value2.toString().split('.')[1].length : 0;
  if (decimalLength) {
    value1 = value1 * Math.pow(10, decimalLength);
    value2 = value2 * Math.pow(10, decimalLength);
  }
  return value1 % value2;
};

export const getMonthNameForScheduledDate = () => {
  const date = new Date();
  return commonConstants.Months[date.getMonth() + 1];
};

export const addNewFolio = (value : any) =>{
  const options = [{label: value,value:value},{label:'New Folio',value : 'New Folio'}];
  return options
}

export const convertArrayOfStringsToDropDownOptionsFormat = (
  arrayOfValues: Array<any>,
  suffix?: boolean,
  suffixText?: string | null
) => {
  const options = [];
  arrayOfValues &&
    arrayOfValues.map((value, index) => {
      options.push({ label: `${suffix ? getDateOrdinal(value) + suffixText : value}`, value: value });
    });
  return options;
};

export const convertArrayOfObjectToDropDownStylingBasedOnDifferentLabelAndValueName = (
  arrayOfObject: Array<object>,
  labelKeyName: string,
  valueKeyName: string
) => {
  const options = [];
  arrayOfObject &&
    arrayOfObject.map((objectData, index) => {
      options.push({ label: objectData[labelKeyName], value: objectData[valueKeyName] });
    });
  return options;
};
